import React, { useEffect, useState } from 'react';
import '../styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { SET_SIZE, UPDATE_STATS } from '../REDUX/actions';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import { HELPED_KEY } from '../const';
import BackButton from '../COMPONENTS/BackButton';
import { Background } from '../COMPONENTS/Background';
import Logo from '../ASSETS/ColorMatchLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import * as f from '../logic.js';
import Title from '../ASSETS/ColorMatchTitle.png';
import { GAME_PAGE, HELP_PAGE } from '../../HOME/const';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

const StartPage = () => {
  const dispatch = useDispatch();
  const { cm } = useSelector(state => state);
  const [dummy, setDummy] = useState(false);

  useEffect(() => {
    const forceUpdate = () => setDummy(!dummy);
    window.addEventListener('resize', forceUpdate);

    return () => {
      window.removeEventListener('resize', forceUpdate);
    };
  }, [dummy]);

  const handleSize = (op, i) => {
    if (!i) {
      dispatch({ type: GOTO_PAGE, payload: { page: HELP_PAGE } });
      return;
    }

    const size = Number(_.words(op)[0]) || 0;
    dispatch({ type: SET_SIZE, size });

    f.getStats(size, stats => {
      dispatch({ type: UPDATE_STATS, stats });
    });

    dbget(HELPED_KEY, response => {
      dispatch({ type: GOTO_PAGE, payload: { page: response || cm.helped ? GAME_PAGE : HELP_PAGE } });
    });
  };

  const { x: wx, y: wy } = windowSize();
  const width = Math.min(wx, wy) / 7;
  const colors = ['#95B0CC', '#2A6099', '#FFFF80', '#FF0', '#FF8080', '#F00'];
  const opx = (wx - 60) / 2;

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <img src={Logo} width={width} alt="Color Match logo" />
        <img src={Title} height={(width * 7) / 9} alt="color match" />
      </div>
      <div className="cm-page" style={{ backgroundImage: Background }}>
        {_.map(['HOW TO PLAY?', '10 MATCHES', '25 MATCHES', '50 MATCHES', '100 MATCHES', 'TETRIS MODE'], (op, i) => {
          return (
            <div
              key={op}
              className="cm-option"
              onClick={() => handleSize(op, i)}
              style={{ gridArea: `${i === 1 ? '1/2' : 'auto'}`, borderColor: `${colors[i]}`, width: `${opx}px`, maxWidth: '200px' }}>
              {op}
            </div>
          );
        })}
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default StartPage;
